<div class="onboarding-command-page">
    <main class="onboarding-command-main px-4 px-xxl-5 py-4">
      <section class="onboarding-hero-panel text-white p-4 mb-4 d-none">
        <div class="d-flex flex-column flex-lg-row justify-content-between gap-3">
          <div>
            <div class="text-uppercase fw-bold onboarding-section-label text-white-50 mb-3">OnboardOS</div>
            <h2 class="h4 fw-bold mb-3">{{ hero_title }}</h2>
            <p class="mb-4 onboarding-hero-copy">
              {{ hero_copy }}
            </p>
          </div>

          <div class="d-flex align-items-start gap-2 flex-shrink-0">
            <button type="button" class="btn btn-sm btn-outline-light d-inline-flex align-items-center gap-2 px-3">
              <i class="bi bi-send"></i>
              <span class="fw-semibold">Send digest</span>
            </button>
            <button type="button" class="btn btn-sm btn-light d-inline-flex align-items-center gap-2 px-3">
              <i class="bi bi-play"></i>
              <span class="fw-semibold">Activate 19</span>
            </button>
          </div>
        </div>

        <div class="row g-4">
          <div class="col-6 col-lg-3">
            <div class="text-uppercase onboarding-section-label text-white-50 mb-2">Active onboarding(s)</div>
            <div class="h3 fw-bold mb-1">{{ active_count }}</div>
            <div class="small text-white-75">{{ scope_caption }}</div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="text-uppercase onboarding-section-label text-white-50 mb-2">Avg cycle time</div>
            <div class="h3 fw-bold mb-1">{{ avg_cycle_time }}</div>
            <div class="small text-white-75">{{ active_journey_label }}</div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="text-uppercase onboarding-section-label text-white-50 mb-2">Activated this week</div>
            <div class="h3 fw-bold mb-1">{{ ready_count }}</div>
            <div class="small text-white-75">Ready to activate</div>
          </div>
          <div class="col-6 col-lg-3">
            <div class="text-uppercase onboarding-section-label text-white-50 mb-2">Synced to Complyon</div>
            <div class="h3 fw-bold mb-1">{{ blocker_count }}</div>
            <div class="small text-white-75">Blocked onboarding(s)</div>
          </div>
        </div>
      </section>

      <section class="row g-3 mb-4">
        <div v-for="stat in stats" :key="stat.label" class="col-12 col-md-6 col-xl">
          <article class="card onboarding-kpi-card onboarding-domain-primary-border h-100">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <div class="text-uppercase onboarding-section-label text-muted mb-2">{{ stat.label }}</div>
                <div :class="['onboarding-kpi-value fw-bold mb-3', `text-${stat.tone}`]">{{ stat.value }}</div>
              </div>

              <div class="d-flex align-items-end justify-content-between gap-3">
                <div class="small text-muted">{{ stat.detail }}</div>
                <div v-if="stat.bars" class="d-flex align-items-end gap-1 onboarding-mini-bars">
                  <span
                    v-for="(height, index) in stat.bars"
                    :key="`${stat.label}-${index}`"
                    :class="[`bg-${stat.tone}`, 'onboarding-chart-bar']"
                    :style="{ '--onboarding-chart-bar-size': `${height}px` }"
                  ></span>
                </div>
                <span v-else class="badge rounded-pill bg-danger-subtle text-danger-emphasis">{{ stat.badge }}</span>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section class="card onboarding-funnel-card onboarding-domain-primary-border">
        <div class="card-header bg-white d-flex flex-column flex-md-row justify-content-between gap-3 px-4 py-3">
          <div>
            <h2 class="h5 fw-bold mb-1">Onboarding funnel</h2>
            <p class="mb-0 small text-muted">{{ funnel_scope_label }}</p>
          </div>
          <div class="d-flex align-items-center gap-3 small">
            <span class="d-inline-flex align-items-center gap-2"><span class="onboarding-dot bg-secondary"></span>Active</span>
            <span class="d-inline-flex align-items-center gap-2"><span class="onboarding-dot bg-danger"></span>Blocked</span>
            <span class="d-inline-flex align-items-center gap-2"><span class="onboarding-dot bg-success"></span>Ready</span>
          </div>
        </div>

        <div class="card-body p-4">
          <div class="row g-0 onboarding-funnel-row">
            <div v-for="item in funnel_steps" :key="item.step" class="col-12 col-sm-6 col-lg-3 col-xxl">
              <div class="onboarding-funnel-step h-100 p-3">
                <div class="text-uppercase onboarding-section-label text-muted mb-2">{{ item.step }} {{ item.label }}</div>
                <div :class="['h4 fw-bold mb-2', `text-${item.tone}`]">{{ item.value }}</div>
                <div class="small text-muted">{{ item.detail }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
</div>
